module.exports = __webpack_public_path__ + "img/z9.a36b47c2.png";